import { Flex } from "antd";

import { useDatasetsMutatorStatus } from "@/modules/datasets/datasets-mutator";
import { useInterventionSectionContext } from "@/modules/intervention/intervention-section-context";
import { ObservationDeleteButton } from "@/modules/observation/observation-delete-button";
import ObservationInvalidationButton from "@/modules/observation/observation-invalidation-button";
import ObservationValidationButton from "@/modules/observation/observation-validation-button";
import ObservationValidationTag from "@/modules/observation/observation-validation-tag";

const InterventionSectionCardExtra = () => {
  const { isDirty, isSaving } = useDatasetsMutatorStatus();
  const {
    observation,
    isEditable,
    intervention,
    observationQuery,
    onObservationDelete,
  } = useInterventionSectionContext();

  const loading = observationQuery.isLoading;
  const disabled = isDirty || isSaving;

  const validation = observation?.validation;

  const invalidateKeys = [["interventions", "menu", intervention.id]];

  return (
    <Flex gap="small">
      <ObservationValidationTag observation={observation} />
      {isEditable && observation && !validation && (
        <ObservationValidationButton
          observationId={observation.id}
          disabled={disabled}
          loading={loading}
          invalidateKeys={invalidateKeys}
        />
      )}
      {isEditable && validation && (
        <ObservationInvalidationButton
          observationId={observation.id}
          disabled={disabled}
          loading={loading}
          invalidateKeys={invalidateKeys}
        />
      )}
      {isEditable && (
        <ObservationDeleteButton
          observation={observation}
          loading={loading}
          disabled={disabled}
          onSuccess={onObservationDelete}
          invalidateKeys={invalidateKeys}
        />
      )}
    </Flex>
  );
};

export default InterventionSectionCardExtra;
